import * as Yup from "yup";
import { InterventionLocation, Maybe, } from "../../generated/graphql";

const getSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required().default(""),
        abbreviation: Yup.string().required().default(""),
    })
}

export const getInitialValues = (schema: Yup.ObjectSchema<any>) => {
    return schema.cast({});
}

const interventionLocationFormInit = (record?: Maybe<InterventionLocation>) => {
    const schema = getSchema()
    const initial = record ? record : getInitialValues(schema)
    return { schema, initial }
}

export default interventionLocationFormInit
